import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const AnnouncementStyled = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 8px 16px;
    font-weight: 400;
    font-size: 12px;
    background: rgba(129, 146, 228, 0.1);
    color: var(--color-white-60);

    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 2px 4px;
        font-size: 11px;
    }
`;
